import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import { userSlice } from "./ducks/user";
import profileReducer from "./ducks/profile"; // default export from above
import countryInfoReducer from "./ducks/countryInfo";
import selectedCountryReducer from "./ducks/selectedCountry";

const userPersistConfig = {
  key: "user", // persist only user slice
  storage,
};

const selectedCountryPersistConfig = {
  key: "selectedCountry",
  storage,
};

const persistedUserReducer = persistReducer(userPersistConfig, userSlice.reducer);
const persistedSelectedCountryReducer = persistReducer(
  selectedCountryPersistConfig,
  selectedCountryReducer,
);

export const store = configureStore({
  reducer: {
    user: persistedUserReducer, // persisted
    profile: profileReducer,    // not persisted
    countryInfo: countryInfoReducer, // not persisted
    selectedCountry: persistedSelectedCountryReducer, // persisted
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
